module.exports = __webpack_public_path__ + "static/media/icon-friends.46e7a462.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-friends.svg
// module id = 1226
// module chunks = 19